import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Row, Col, Select, Button, Table, Typography, Card } from "antd";

const { Option } = Select;
const { Title } = Typography;

const CekTarif = () => {
  // const navigate = useNavigate();

  const [citySender, setCitySender] = useState("");
  const [cityReceiver, setCityReceiver] = useState("");
  const [serviceChoosen, setServiceChoosen] = useState("");
  const [dimensionChoosen, setDimensionChoosen] = useState("");
  const [tarifData, setTarifData] = useState([]);
  const [tarifError, setTarifError] = useState(false);
  const [countries, setCountries] = useState([]);
  const [services, setServices] = useState([]);
  const [dimension, setDimension] = useState([]);
  const history = useHistory();

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/referensi/country`
        );
        if (Array.isArray(response.data.data)) {
          setCountries(response.data.data);
        } else {
          setCountries([]);
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
        setCountries([]);
      }
    };

    const fetchDimension = async () => {
      const dataDimensi = [
        {
          key: "1",
          services: "Document / Standart Document Ampelope (22 x 30 cm (A4))",
          tarif: "IDR 1.683.794,53 ~ IDR 4.592.166,90 ",
          estimasi: "10-12 Days",
        },
        {
          key: "2",
          services: "Small Package (30 x 30 x 30 cm) (Max 2-5 Kg)",
          tarif: " IDR 1.683.794,53 ~ IDR 4.592.166,90 ",
          estimasi: "10-12 Days",
        },
        {
          key: "3",
          services: "Medium Package (50 x 50 x 50 cm) (Max 25-30 Kg)",
          tarif: " IDR 3.826.805,75 ~ IDR 4.592.166,90 ",
          estimasi: "10-12 Days",
        },
        {
          key: "4",
          services: "Large Package (100 x 100 x 100 cm) (Max 50-70 Kg)",
          tarif: " IDR 7.653.611,50 ~ IDR 10.715.056,10",
          estimasi: "12-15 Days",
        },
      ];

      setDimension(dataDimensi);
    };

    const fetchServices = async () => {
      const dataServices = [{ key: "1", services: "Express (10-12 Days)" }];
      setServices(dataServices);
    };

    fetchCountries();
    fetchServices();
    fetchDimension();
  }, []);

  const handleTarifSubmit = () => {
    if (!citySender || !cityReceiver || !serviceChoosen || !dimensionChoosen) {
      setTarifError(true);
      return;
    }

    setTarifError(false);

    const data = [
      {
        key: "1",
        sender: citySender,
        receiver: cityReceiver,
        layanan: serviceChoosen,
        tarifEst: dimensionChoosen,
        estimasi: "10-12 Days",
      },
    ];
    setTarifData(data);
  };

  const columns = [
    { title: "Services", dataIndex: "layanan", key: "layanan" },
    { title: "Rate (IDR)", dataIndex: "tarifEst", key: "tarifEst" },
    { title: "Estimate (Days)", dataIndex: "estimasi", key: "estimasi" },
  ];

  const handleCreateShipment = () => {
    history.push(`/create-shipment`);
  };

  return (
    <div className="col-lg-12">
      <Card
        title={
          <h5
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              textAlign: "center",
            }}
          >
            Estimate Shipment Rate
          </h5>
        }
        bordered={false}
        className="mb-4 shadow-sm"
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <Title level={5}>Origin</Title>
            <Select
              showSearch
              allowClear
              placeholder="Select Origin Country"
              style={{ width: "100%" }}
              value={citySender || undefined}
              onChange={setCitySender}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {countries.map((country) => (
                <Option key={country.idCountry} value={country.countryName}>
                  {country.countryName}
                </Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} sm={12}>
            <Title level={5}>Destination</Title>
            <Select
              showSearch
              allowClear
              placeholder="Select Destination Country"
              style={{ width: "100%" }}
              value={cityReceiver || undefined}
              onChange={setCityReceiver}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {countries.map((country) => (
                <Option key={country.idCountry} value={country.countryName}>
                  {country.countryName}
                </Option>
              ))}
            </Select>
          </Col>
        </Row>

        <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
          <Col xs={24} sm={12}>
            <Title level={5}>Services</Title>
            <Select
              showSearch
              allowClear
              placeholder="Select Shipment Service"
              style={{ width: "100%" }}
              value={serviceChoosen || undefined}
              onChange={setServiceChoosen}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {services.map((service) => (
                <Option key={service.key} value={service.services}>
                  {service.services}
                </Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} sm={12}>
            <Title level={5}>Package Type</Title>
            <Select
              showSearch
              allowClear
              placeholder="Select Package Type"
              style={{ width: "100%" }}
              value={dimensionChoosen || undefined}
              onChange={setDimensionChoosen}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {dimension.map((dim) => (
                <Option key={dim.key} value={dim.tarif}>
                  {dim.services}
                </Option>
              ))}
            </Select>
          </Col>
        </Row>

        {tarifError && (
          <p style={{ color: "red", marginTop: "50px" }}>
            All fields must be filled!
          </p>
        )}

        <Button
          type="primary"
          block
          onClick={handleTarifSubmit}
          style={{
            marginTop: "20px",
            backgroundColor: "#FFC107",
            borderColor: "#FFC107",
            color: "#000",
            fontWeight: "bold",
          }}
        >
          Calculate
        </Button>
      </Card>

      {tarifData.length > 0 && (
        <Card
          title={
            <h5
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                textAlign: "center",
                color: "#28a745",
              }}
            >
              Estimated Price from {citySender} to {cityReceiver}
            </h5>
          }
          className="mt-4"
        >
          <Table
            columns={columns}
            dataSource={tarifData}
            pagination={false}
            bordered
          />
          <span
            style={{
              fontSize: "12px",
              color: "red",
              display: "block",
              textAlign: "left",
              marginTop: "5px",
            }}
          >
            *The quoted price is an estimate, inclusive of shipping and handling
            services, but exclusive of any customs-related charges.
          </span>
          <Button
            type="primary"
            block
            onClick={handleCreateShipment}
            style={{
              marginTop: "20px",
              backgroundColor: "#28a745",
              borderColor: "#28a745",
              color: "#fff",
              fontWeight: "bold",
            }}
          >
            Create My Shipment Now
          </Button>
        </Card>
      )}
    </div>
  );
};

export default CekTarif;
